import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconWindowCollapse = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M20 4l-6 6' />
      <path d='M14 5v5h5' />
      <path d='M4 20l6-6' />
      <path d='M10 19v-5H5' />
    </g>
  </SDIcon>
)

export default IconWindowCollapse
